/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import { Grid, GridItem, Box } from "@domestika-dev/prudencio/dist/atoms/Layout";

import { DeleteButton, SaveDraftButton, PublishButton } from ".";

export const ProjectFormMenu = ({
  deleteProject,
  saveDraft,
  publishProject,
  deleteDisabled,
  publishDisabled,
  isMobile,
  reference,
}) => {
  return (
    <Box
      position={["fixed", "fixed", "inherit"]}
      backgroundColor="coco"
      bottom={0}
      left={0}
      width="100%"
      padding={[5, 5, 0]}
      zIndex={11}
      ref={reference}
    >
      <Grid gridTemplateColumns="1fr 1fr">
        <GridItem gridColumn="1">
          <DeleteButton
            deleteProject={deleteProject}
            disabled={deleteDisabled}
            dataLabel="project-delete"
          />
        </GridItem>

        <GridItem gridColumn="8" marginRight={4}>
          <SaveDraftButton
            saveDraft={saveDraft}
            message={
              isMobile ? "projects.new.save_draft.mobile_button" : "projects.new.save_draft.button"
            }
            dataLabel="project-save-draft"
          />
        </GridItem>

        <GridItem gridColumn="9">
          <PublishButton
            publishProject={publishProject}
            disabled={publishDisabled}
            message="projects.new.publish.button"
            dataLabel="project-publish"
          />
        </GridItem>
      </Grid>
    </Box>
  );
};

ProjectFormMenu.propTypes = {
  deleteProject: PropTypes.func,
  saveDraft: PropTypes.func,
  publishProject: PropTypes.func,
  deleteDisabled: PropTypes.string,
  publishDisabled: PropTypes.bool,
  isMobile: PropTypes.bool,
  reference: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

ProjectFormMenu.defaultProps = {
  deleteProject: () => {},
  saveDraft: () => {},
  publishProject: () => {},
  deleteDisabled: null,
  publishDisabled: false,
  isMobile: false,
  reference: () => {},
};

export default ProjectFormMenu;
